import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GeneralFormComponent} from '../../general/form/generalForm.component';
import {MessageService} from '../../../../shared/message.service';
import {QuestionService} from '../../../services/question.service';
import {QuestionControlService} from '../../../services/question-control.service';
import {UserRightService} from '../../../services/user-right.service';
import {UserRight} from '../../../interfaces/userRight';
import {ServiceAnswer} from '../../../../shared/service-answer';
import {UserRightGroupService} from '../../../services/user-group-right.service';
import {UserRightGroupUi} from '../../../interfaces/userRightGroupUi';
import {ServiceTools} from '../../../services/serviceTools';

@Component({
  selector: 'app-user-group-details',
  templateUrl: './userRight-form.component.html',
  styleUrls: ['./userRight-form.component.css']
})
export class UserRightFormComponent extends GeneralFormComponent<UserRight> implements OnInit {

  public userRightsGroupUis: UserRightGroupUi[];

  constructor(
    route: ActivatedRoute,
    location: Location,
    messagesService: MessageService,
    router: Router,
    questionService: QuestionService,
    userRightService: UserRightService,
    questionControlService: QuestionControlService,
    private userRightGroupUiService: UserRightGroupService
  ) {
    super(route, userRightService, location, messagesService, router, questionService, questionControlService,
      {
        entityNameSingular: 'user right',
        entityNamePlural: 'user rights',
        formUrl: 'userright',
        listUrl: 'userrights',
        generalFormMetaName: 'user-right'
      });
  }

  /**
   * Inits the view.
   */
  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    if (!this.isNew()) {
      this.userRightsGroupUis = await this.userRightGroupUiService.getGroupsOfRightUis(+this.getIdFromUrl());
    }
  }

  /**
   * Calls super.contextChanged and refreshes user right groups array.
   */
  async contextChanged(): Promise<void> {
    await super.contextChanged();
    if (!this.isNew()) {
      this.userRightsGroupUis = await this.userRightGroupUiService.getGroupsOfRightUis(+this.getIdFromUrl());
    }
  }

  /**
   * Saves the user right and the user right groups.
   */
  async save(): Promise<void> {
    await super.save();
    if (!this.isNew()) {
      try {
        const serviceAnswer: ServiceAnswer<any> =
          await this.userRightGroupUiService.saveGroupsOfRightUis(
            +this.getIdFromUrl(),
            this.userRightsGroupUis);
        if (!serviceAnswer.isOk) {

          const errorMessage = ServiceTools.getErrorMessage(serviceAnswer, 'Error when storing user rights of group');
          console.error(errorMessage);
          this.messagesService.addDanger(errorMessage);
        }
      } catch (error) {
        console.error('Error when storing user rights of group: ' + error);
        this.messagesService.addDanger('Storing user rights of group failed: ' + error);
      }
    }
  }
}
